import { useState } from 'react';
import { handleError } from '../../../components/errors/errorHandling';
import { createOrganizationSetting as createOrganizationSettingService } from '../../../services/organization/OrganizationService';

interface Values {
  isLoading: boolean;
  createOrganizationSetting: (organizationId: string, settings: any) => Promise<number>;
}

const useCreateOrganizationSetting = (): Values => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const createOrganizationSetting = async (organizationId: string, setting: any): Promise<number> => {
    try {
      setIsLoading(true);

      const result = await createOrganizationSettingService(organizationId, setting);
      setIsLoading(false);
      return result.data;
    } catch (error) {
      handleError(error);
      setIsLoading(false);
      return 0;
    }
  };

  return { createOrganizationSetting, isLoading };
};

export default useCreateOrganizationSetting;
